// ** Initial State
const initialState = {
  allData: [],
  data: [],
  total: 1,
  params: {},
  info: [],
  message: "",
  single: {},
  radio_by_id: {},
  error: null,
};
const RadioReducer = (state = initialState, action) => {
  switch (action.type) {
    case "GET_RADIO":
      return {
        ...state,
        data: action.data,
        total: action.totalPages,
        params: action.params,
        allData: action.data,
      };
    case "GET_ALL_RADIO":
      return {
        ...state,
        allData: action.data,
        data: action.data,
        params: action.params,
        total: action.totalPages,
      };
    case "GET_RADIO_NAME":
      return {
        ...state,
        single: action.data,
      };
    case "GET_RADIO_ID":
      return {
        ...state,
        radio_by_id: action.data,
      };
    case "EMPTY_ERROR":
    case "ADD_RADIO_SUCCESS":
    case "EDIT_RADIO_SUCCESS":
      return { ...state, error: null };
    case "ADD_RADIO_FAIL":
    case "EDIT_RADIO_FAIL":
      return { ...state, error: action.payload };
    default:
      return { ...state };
  }
};

export default RadioReducer;
